import '@hotwired/turbo-rails'

// Font Awesome
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'

// Fonts
import '@fontsource/open-sans'
import '@fontsource/open-sans/400.css'
import '@fontsource/open-sans/400-italic.css'
import '@fontsource/open-sans/700.css'
import '@fontsource/open-sans/700-italic.css'

// Vue
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue/client'
import router from '$/router.ts'
import { i18n } from '$/locales'
import App from '&/App.vue'
import Notifications from '@kyvg/vue3-notification'
// import AppBreadcrumbs from '&/AppBreadcrumbs.vue'
import VueSafeHTML from 'vue-safe-html'
import { VueRecaptchaPlugin } from 'vue-recaptcha'
import AppAdSense from '&/adsense/AppAdSense.vue'

import '@/builds/tailwind.css'

document.addEventListener('turbo:load', () => {
  const app = createApp(App)
  const pinia = createPinia()
  const head = createHead()

  app.use(pinia)
  app.use(head)
  app.use(router)
  app.use(i18n)
  app.use(Notifications)
  app.use(VueSafeHTML)
  // app.component('AppBreadcrumbs', AppBreadcrumbs)
  app.component('AppAdSense', AppAdSense)
  app.use(VueRecaptchaPlugin, {
    v2SiteKey: '6Lenp5UqAAAAABTk___RuZZPi8pJg65kao6VpC0s',
  })

  app.mount('#app')

  import('../channels')

  // ===== Sub-menu
  const submenuItems = document.querySelectorAll('.submenu-item')
  submenuItems.forEach((el) => {
    el.querySelector('a').addEventListener('click', () => {
      el.querySelector('.submenu').classList.toggle('hidden')
    })
  })
})
